// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const groupApi = baseApi.injectEndpoints({
  reducerPath: "groupApi",
  endpoints: (builder) => ({
    getAllGroups: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/groups?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    groupStatus: builder.mutation({
        query: (id) => {
          return {
            url: `admin/groups/status/${id}`,
            method: "PUT",
            // body: data,
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        // invalidatesTags: ['User'],
      }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllGroupsQuery,
  useGroupStatusMutation,
} = groupApi;
